import styled from 'styled-components/macro';
import { Typography } from '@redis-ui/components';

export const DontHaveAnAccountText = styled(Typography.Body)`
  margin-bottom: 3.2rem;
`;
